import {Delete, Edit, MoreVert} from "@mui/icons-material";
import {IconButton, Menu, MenuItem, Typography} from "@mui/material";
import React from "react";
import {Grey17, Grey6} from "../../theme/styles";
import css_self from "../Navigation/css/NavBar.module.scss";
import {EnlilTable} from "../EnlilTable";
import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import EventBus from "../../util/EventBus";
import css_buttons from "../Common/css/CCButton.module.scss";
import ETLS3ConfigurationFormApplet from "../../eoec/applet/impl/ETLS3Configuration/ETLS3ConfigurationFormApplet";

class ETLS3ConfigurationTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("etl-s3-configuration-form-edit-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("etl-s3-configuration-form-edit-applet-save", this.onCancelHandler);
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("etl-s3-configuration-form-edit-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("etl-s3-configuration-form-edit-applet-save", this.onCancelHandler);
    }

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        } else if (name === "Success Cell") {
            return this.renderSuccessCell;
        } else if (name === "Failure Cell") {
            return this.renderFailureCell;
        }
        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "New S3 Configuration") {
            this.setState({renderTarget: "New S3 Configuration"});
        }
        super.handleMenuClick(identifier);
    }

    renderExtension() {
        if (this.state.renderTarget === "New S3 Configuration") {
            return <ETLS3ConfigurationFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="New"/>;
        } else if (this.state.renderTarget === "Edit S3 Configuration") {
            return <ETLS3ConfigurationFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Edit"/>;
        } else if (this.state.renderTarget === "Delete S3 Configuration") {
            return <ETLS3ConfigurationFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Delete"/>;
        }
    };

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-9px", paddingLeft: "8px", marginRight: "auto", marginTop: "auto", marginBottom: "auto", height: "100%"}}>
                <IconButton className={css_buttons.blueIconButton} onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Edit S3 Configuration"});
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Edit S3 Configuration</Typography>
                    </MenuItem>
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Delete S3 Configuration"});
                    }}>
                        <Delete style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Delete S3 Configuration</Typography>
                    </MenuItem>
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(ETLS3ConfigurationTable)));